import React, { lazy, memo } from 'react';
const SplitSections = () => {
  return <section className="py-20 bg-white" data-id="element-802">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-803">
        <div className="text-center mb-16" data-id="element-804">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-805">
            Luxury Spa Beverage Solutions
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-806">
            Tailored beverage experiences for premium spas that elevate
            wellness, enhance guest satisfaction, and increase client lifetime
            value
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-807">
          <div data-id="element-808">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-809">
              Elevate the Guest Experience
            </h3>
            <ul className="space-y-4" data-id="element-810">
              <li className="flex" data-id="element-811">
                <div className="flex-shrink-0" data-id="element-812">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-813">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-814">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-815" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-816">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-817">
                    Premium Welcome Ritual
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-818">
                    Create a memorable first impression with personalized
                    wellness beverages that set the tone for a luxury spa
                    journey.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-819">
                <div className="flex-shrink-0" data-id="element-820">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-821">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-822">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-823" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-824">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-825">
                    Treatment-Enhancing Beverages
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-826">
                    Complement your spa treatments with curated beverages
                    designed to enhance relaxation, detoxification, or
                    revitalization.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-827">
                <div className="flex-shrink-0" data-id="element-828">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-829">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-830">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-831" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-832">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-833">
                    Functional Wellness Beverages
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-834">
                    Offer vitamin-infused, alkaline, and functional beverages
                    that support your clients' wellness journey and health
                    goals.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div data-id="element-835">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-836">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/facHzgrQHSa9UViHDnhCqD/Spa2.webp" alt="Spa guests in white robes enjoying premium SmartSoda wellness beverages in a luxury setting" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-837" />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-838">
          <div className="order-2 lg:order-1" data-id="element-839">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-840">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jfvho8bVgo9QiatfdNtJCY/Spa3.webp" alt="Group of diverse spa guests in white robes toasting with colorful wellness beverages in an elegant spa lounge" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-841" />
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-842">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-843">
              Create Social Wellness Moments
            </h3>
            <ul className="space-y-4" data-id="element-844">
              <li className="flex" data-id="element-845">
                <div className="flex-shrink-0" data-id="element-846">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-847">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-848">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-849" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-850">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-851">
                    Shared Wellness Experiences
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-852">
                    Foster connections between guests with vibrant,
                    Instagram-worthy wellness beverages that become a talking
                    point in your relaxation spaces.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-853">
                <div className="flex-shrink-0" data-id="element-854">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-855">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-856">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-857" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-858">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-859">
                    Luxury Relaxation Lounges
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-860">
                    Transform your relaxation areas into premium social spaces
                    where guests can unwind together while enjoying customized
                    wellness beverages.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-861">
                <div className="flex-shrink-0" data-id="element-862">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-863">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-864">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-865" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-866">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-867">
                    Memorable Group Experiences
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-868">
                    Enhance spa parties, couples retreats, and group packages
                    with signature beverage offerings that create lasting
                    memories and encourage repeat visits.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20" data-id="element-869">
          <div data-id="element-870">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-871">
              Transform Your Client Relationships
            </h3>
            <ul className="space-y-4" data-id="element-872">
              <li className="flex" data-id="element-873">
                <div className="flex-shrink-0" data-id="element-874">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-875">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-876">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-877" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-878">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-879">
                    Increase Client Retention
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-880">
                    Create a memorable touchpoint that enhances the overall spa
                    experience, leading to higher satisfaction scores and
                    reduced client churn.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-881">
                <div className="flex-shrink-0" data-id="element-882">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-883">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-884">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-885" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-886">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-887">
                    Elevate Your Spa Brand
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-888">
                    Stand out from competitors with a signature beverage program
                    that becomes an integral part of your luxury spa identity.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-889">
                <div className="flex-shrink-0" data-id="element-890">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-891">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-892">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-893" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-894">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-895">
                    Eco-Luxury Credentials
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-896">
                    Strengthen your sustainability commitment by eliminating
                    single-use plastics while enhancing the premium nature of
                    your offerings.
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div data-id="element-897">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-898">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mfXJBCMiDqwAQBEAi97CHw/Medispa_4.webp" alt="Spa guests enjoying SmartSoda wellness beverages in a relaxation lounge" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-899" />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-900">
          <div className="order-2 lg:order-1" data-id="element-901">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-80 lg:h-96" data-id="element-902">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gU7cgoBFKUTsGV4L88nbzD/Medispa_3.webp" alt="SmartSoda machine elegantly integrated into a luxury spa relaxation lounge" className="w-full h-full object-cover object-center" width="600" height="400" loading="lazy" decoding="async" data-id="element-903" />
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-904">
            <h3 className="text-2xl font-bold text-navy-950 mb-6" data-id="element-905">
              Seamless Integration Into Your Spa
            </h3>
            <ul className="space-y-4" data-id="element-906">
              <li className="flex" data-id="element-907">
                <div className="flex-shrink-0" data-id="element-908">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-909">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-910">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-911" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-912">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-913">
                    Elegant Design
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-914">
                    Our sleek, modern dispensing systems blend seamlessly with
                    your luxury spa aesthetic and can be customized to match
                    your decor.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-915">
                <div className="flex-shrink-0" data-id="element-916">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-917">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-918">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-919" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-920">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-921">
                    Versatile Placement Options
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-922">
                    Position systems in reception areas, relaxation lounges,
                    treatment rooms, or any space where guests can enjoy premium
                    refreshment.
                  </p>
                </div>
              </li>
              <li className="flex" data-id="element-923">
                <div className="flex-shrink-0" data-id="element-924">
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-925">
                    <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-926">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-927" />
                    </svg>
                  </div>
                </div>
                <div className="ml-4" data-id="element-928">
                  <h4 className="text-lg font-medium text-navy-950" data-id="element-929">
                    Staff-Friendly Operation
                  </h4>
                  <p className="mt-2 text-gray-600" data-id="element-930">
                    Intuitive touchscreen interface and minimal maintenance
                    requirements allow your team to focus on delivering
                    exceptional service.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-931">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-932">
            Transform Your Spa Experience
          </a>
        </div>
      </div>
    </section>;
};
export default SplitSections;